import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { Toaster } from 'react-hot-toast';
import Login from './components/auth/Login';
import SignUp from './components/auth/SignUp';
import ResetPassword from './components/auth/ResetPassword';
import Dashboard from './components/dashboard/Dashboard';
import PropertyManager from './components/properties/PropertyManager';
import GuestPageManager from './components/guestPages/GuestPageManager';
import GuestPortal from './components/portal/GuestPortal';
import AutomationSettings from './components/automation/AutomationSettings';
import EmailSettings from './components/email/EmailSettings';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Layout from './components/shared/Layout';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Router>
          <div className="min-h-screen bg-[#eef2f6]">
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/portal/:slug" element={<GuestPortal />} />

              {/* Protected Routes wrapped in Layout */}
              <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/properties" element={<PropertyManager />} />
                <Route path="/guest-pages" element={<GuestPageManager />} />
                <Route path="/automation" element={<AutomationSettings />} />
                <Route path="/email-settings" element={<EmailSettings />} />
              </Route>

              {/* Default Redirect */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <Toaster position="top-right" />
          </div>
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;